<template>
  <div class="bg-gray-50">

        <!-- menu component -->
        <menu-public></menu-public>
        
        <div class="mb-16 mx-auto max-w-7xl px-4  sm:px-6">

            <!-- This example requires Tailwind CSS v2.0+ -->
                <div class="h-screen flex overflow-hidden bg-gray-100">

                <div class="flex flex-col w-0 flex-1 overflow-hidden">


                    <div class="md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3">
                    <button class="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                        <span class="sr-only">Open sidebar</span>
                        <!-- Heroicon name: menu -->
                        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>
                    </div>
                    <main class="flex-1 relative z-0 overflow-y-auto focus:outline-none" tabindex="0">

                    <div class="py-6">
                        <!-- <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                        <h1 class="text-2xl font-semibold text-gray-900">Subscriptions</h1>
                        </div> -->
                        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                            <!-- Replace with your content -->
                            <div class="py-4">

                                  <div class="pt-12 sm:pt-16 lg:pt-20">
                                      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                                        <div class="text-center">
                                            <h2 class="text-3xl font-extrabold text-gray-900 sm:text-4xl lg:text-5xl">
                                            Create | Manage Subscriptions
                                            </h2>
                                            <p class="mt-4 text-xl text-gray-600">
                                                
                                            </p>
                                        </div>

                                      </div>
                                  </div>

                                    <div class="lg:border-t lg:border-b lg:border-gray-200">
                                      <nav class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" aria-label="Progress">
                                        <ol class="rounded-md overflow-hidden lg:flex lg:border-l lg:border-r lg:border-gray-200 lg:rounded-none">
                                          <li class="relative overflow-hidden lg:flex-1">
                                            <div class="border border-gray-200 overflow-hidden border-b-0 rounded-t-md lg:border-0">
                                              <!-- Completed Step -->
                                              <a @click="isOpen = !isOpen" class="group">
                                                <span class="absolute top-0 left-0 w-1 h-full bg-transparent group-hover:bg-gray-200 lg:w-full lg:h-1 lg:bottom-0 lg:top-auto" aria-hidden="true"></span>
                                                <span class="px-6 py-5 flex items-start text-sm font-medium">
                                                  <span class="flex-shrink-0">
                                                    <span class="w-10 h-10 flex items-center justify-center border-2 border-indigo-600 rounded-full">
                                                      <span class="text-indigo-600">01</span>
                                                    </span>
                                                  </span>
                                                  <span class="mt-0.5 ml-4 min-w-0 flex flex-col">
                                                    <span class="text-xs font-semibold uppercase tracking-wide">Create New User</span>
                                                    <span class="text-sm font-medium text-gray-500">display a modal and form</span>
                                                  </span>
                                                </span>
                                              </a>
                                            </div>
                                          </li>

                                          <li class="relative overflow-hidden lg:flex-1">
                                            <div class="border border-gray-200 overflow-hidden lg:border-0">
                                              <!-- Current Step -->
                                              <a @click="displayCreate()" aria-current="step">
                                                <span class="absolute top-0 left-0 w-1 h-full bg-indigo-600 lg:w-full lg:h-1 lg:bottom-0 lg:top-auto" aria-hidden="true"></span>
                                                <span class="px-6 py-5 flex items-start text-sm font-medium lg:pl-9">
                                                  <span class="flex-shrink-0">
                                                    <span class="w-10 h-10 flex items-center justify-center border-2 border-indigo-600 rounded-full">
                                                      <span class="text-indigo-600">02</span>
                                                    </span>
                                                  </span>
                                                  <span class="mt-0.5 ml-4 min-w-0 flex flex-col">
                                                    <span class="text-xs font-semibold text-indigo-600 uppercase tracking-wide">Create Subscriptions</span>
                                                    <span class="text-sm font-medium text-gray-500">Manage.</span>
                                                  </span>
                                                </span>
                                              </a>

                                              <div class="hidden absolute top-0 left-0 w-3 inset-0 lg:block" aria-hidden="true">
                                                <svg class="h-full w-full text-gray-300" viewBox="0 0 12 82" fill="none" preserveAspectRatio="none">
                                                  <path d="M0.5 0V31L10.5 41L0.5 51V82" stroke="currentcolor" vector-effect="non-scaling-stroke" />
                                                </svg>
                                              </div>
                                            </div>
                                          </li>

                                          <li class="relative overflow-hidden lg:flex-1">
                                            <div class="border border-gray-200 overflow-hidden border-t-0 rounded-b-md lg:border-0">
                                              <!-- Upcoming Step -->
                                              <a @click="displayManage()" class="group">
                                                <span class="absolute top-0 left-0 w-1 h-full bg-transparent group-hover:bg-gray-200 lg:w-full lg:h-1 lg:bottom-0 lg:top-auto" aria-hidden="true"></span>
                                                <span class="px-6 py-5 flex items-start text-sm font-medium lg:pl-9">
                                                  <span class="flex-shrink-0">
                                                    <span class="w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full">
                                                      <span class="text-gray-500">03</span>
                                                    </span>
                                                  </span>
                                                  <span class="mt-0.5 ml-4 min-w-0 flex flex-col">
                                                    <span class="text-xs font-semibold text-indigo-600 uppercase tracking-wide">Manage Subscriptions</span>
                                                    <span class="text-sm font-medium text-gray-500">Edit - Update - Remove</span>
                                                  </span>
                                                </span>
                                              </a>

                                              <div class="hidden absolute top-0 left-0 w-3 inset-0 lg:block" aria-hidden="true">
                                                <svg class="h-full w-full text-gray-300" viewBox="0 0 12 82" fill="none" preserveAspectRatio="none">
                                                  <path d="M0.5 0V31L10.5 41L0.5 51V82" stroke="currentcolor" vector-effect="non-scaling-stroke" />
                                                </svg>
                                              </div>
                                            </div>
                                          </li>

                                          <li class="relative overflow-hidden lg:flex-1">
                                            <div class="border border-gray-200 overflow-hidden border-t-0 rounded-b-md lg:border-0">
                                              <!-- Upcoming Step -->
                                              <a @click="displaySingle()" class="group">
                                                <span class="absolute top-0 left-0 w-1 h-full bg-transparent group-hover:bg-gray-200 lg:w-full lg:h-1 lg:bottom-0 lg:top-auto" aria-hidden="true"></span>
                                                <span class="px-6 py-5 flex items-start text-sm font-medium lg:pl-9">
                                                  <span class="flex-shrink-0">
                                                    <span class="w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full">
                                                      <span class="text-gray-500">04</span>
                                                    </span>
                                                  </span>
                                                  <span class="mt-0.5 ml-4 min-w-0 flex flex-col">
                                                    <span class="text-xs font-semibold text-indigo-600 uppercase tracking-wide">Single Charge | Subscription</span>
                                                    <!-- <span class="text-sm font-medium text-gray-500">Edit - Update</span> -->
                                                  </span>
                                                </span>
                                              </a>

                                              <div class="hidden absolute top-0 left-0 w-3 inset-0 lg:block" aria-hidden="true">
                                                <svg class="h-full w-full text-gray-300" viewBox="0 0 12 82" fill="none" preserveAspectRatio="none">
                                                  <path d="M0.5 0V31L10.5 41L0.5 51V82" stroke="currentcolor" vector-effect="non-scaling-stroke" />
                                                </svg>
                                              </div>
                                            </div>
                                          </li>

                                        </ol>
                                      </nav>
                                    </div>


                                      <template v-if="showCreate">

                                          <div class="mt-8 bg-white pb-16 sm:mt-12 sm:pb-20 lg:pb-28">
                                              <div class="relative">
                                              <div class="absolute inset-0 h-1/2 bg-gray-100"></div>
                                              <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                                                  <div class="max-w-lg mx-auto rounded-lg shadow-lg overflow-hidden lg:max-w-none lg:flex">
                                                  <div class="flex-1 bg-white px-6 py-8 lg:p-12">
                                          
                                                        <input 
                                                        type="text" 
                                                        v-model="subName" 
                                                        class="max-w-lg text-4xl block w-full p-2 font-extrabold focus:ring-indigo-500 focus:border-indigo-500 rounded-md">

                                                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                                                          <textarea
                                                          v-model="subDescription"   
                                                          rows="3" 
                                                          class=" shadow-sm block w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md">
                                                          </textarea>
                                                          <p class="mt-2 text-sm text-gray-400">Write brief description about the product.</p>
                                                        </div>
                                        
                                                            <div>
                                                              <label for="location" class="block text-sm font-medium text-gray-700">Bill Period</label>
                                                              <select  v-model="subPeriod" class="mt-1 block w-full pl-3 pr-10 py-2 border text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
                                                                <option selected>Month</option>
                                                                <option>Year</option>
                                                                <option>3 Months</option>
                                                                <option>6 Months</option>
                                                                <option>EU</option>
                                                              </select>
                                                            </div>
                                                            
                  
                                                  </div>
                                                  <div class="py-8 px-6 text-center bg-gray-50 lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-center lg:p-12">
                                                      <p class="text-lg leading-6 font-medium text-gray-900">
                                                        Pay a subscription, recurrent
                                                      </p>
                                                      <div class="mt-4 flex items-center justify-center text-7xl font-extrabold text-gray-900">
                                                        <span>
                                                            <input 
                                                            type="text"
                                                            class="p-2"
                                                            style="width: 2.5em; overflow: auto;" 
                                                            v-model="subPrice" >
                                                   
                                                        </span>
                                                        <span class="text-xl font-medium text-gray-500">
                                                            USD
                                                        </span>
                                                      </div>

                                                        <div class="relative">
                                                          <div class="absolute inset-0 flex items-center" aria-hidden="true">
                                                            <div class="w-full border-t border-gray-300"></div>
                                                          </div>
                                                          <div class="relative flex justify-center">
                                                            <span class="px-2 bg-white text-sm text-gray-500">
                                                              save
                                                            </span>
                                                          </div>
                                                        </div>

                                                      <div class="mt-6">
                                                      <div class="rounded-md shadow">
                                                          <a @click="createSub()"  class="flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gray-800 hover:bg-gray-900">
                                                            Create Subscription
                                                          </a>
                                                      </div>
                                                      </div>
                                                  </div>
                                                  </div>
                                              </div>
                                              </div>
                                          </div>

                                      </template>

                                      <template v-if="showManage">
                                  
                                           <div class="mt-8 bg-white pb-16 sm:mt-12 sm:pb-20 lg:pb-28">

                                              <!-- This example requires Tailwind CSS v2.0+ -->
                                              <div class="flex flex-col">
                                                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                                  <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                                      <table class="min-w-full divide-y divide-gray-200">
                                                        <thead class="bg-gray-50">
                                                          <tr>
                                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                              Name
                                                            </th>

                                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                              Active
                                                            </th>

                                                            
                                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                              Assign To:
                                                            </th>


                                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                              Actions
                                                            </th>
           
                                                          </tr>
                                                        </thead>
                                                        <tbody class="bg-white divide-y divide-gray-200">
                                                          <tr v-for="prod in plans.data" :key="prod.name">
                                                            <td class="px-6 py-4 whitespace-nowrap">
                                                              <div class="text-sm text-gray-900">{{ prod.metadata.product_name}} </div>
                                                            </td>
                                                            <!-- <td class="px-6 py-4 whitespace-nowrap">
                                                              <div class="text-sm text-gray-900">{{ prod.metadata.description}}</div>
                                                            </td> -->
                                                            <td class="px-6 py-4 whitespace-nowrap">

                                                              <span v-if="prod.active == true" class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                                                {{ prod.active }}
                                                              </span>
                                                              <span v-else class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
                                                                 {{ prod.active }}
                                                              </span>
                                                            </td>

                                                            <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                                  <span class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800">
                                                                     ..
                                                                  </span>
                                                            </td>


                                                            <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                                  <button @click="importContacts(prod)" type="button" class="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                                    Assign to
                                                                  </button>
                                                            </td>
                                                          </tr>

                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>



                                          </div>
                                      </template>

                                      <template v-if="showSingle">
                                  
                                     
                                      </template>


                            </div>
                            <!-- /End replace -->
                        </div>
                    </div>
                    </main>
                </div>
                </div>
        </div>
     



      <div v-if="isOpen"> 
          <modal-page v-on:event="isOpen = false"> </modal-page>
      </div>

      <div v-if="showSingle"> 

            <!-- Modal -->
            <!-- This example requires Tailwind CSS v2.0+ -->
                <div class="fixed z-10  inset-0 overflow-y-auto">
                <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">


                    <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>

                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <div class="md:text-left h-full w-full inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-6/12 " role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <div class="pt-12 sm:pt-16 lg:pt-20">
                              <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                                <div class="text-center">
                                    <h2 class="text-3xl font-extrabold text-gray-900 sm:text-4xl lg:text-5xl">
                                      Create Single charge
                                    </h2>

                                    <p class="mt-4">
                                          <!-- This example requires Tailwind CSS v2.0+ -->
                                          <button @click="importContacts()" type="button" class="inline-flex items-center px-3.5 py-2 border border-transparent text-sm leading-4 font-medium rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                            Import Contact
                                          </button>
                                    </p>
                                </div>

        
                              </div>

                              <!-- This example requires Tailwind CSS v2.0+ -->
                                <div class="relative">
                                  <div class="absolute inset-0 flex items-center" aria-hidden="true">
                                    <div class="w-full border-t border-gray-300"></div>
                                  </div>
                                  <div class="relative flex justify-center">
                                    <span class="px-2 bg-white text-sm text-gray-500">
                                      Add users | or create a new 
                                    </span>
                                  </div>
                                </div>

                          </div>

                          <div class="font-weight-light title mb-2">

                            <v-form v-if="selectedClient" v-model="valid">

                              <v-container>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
                                      v-model="selectedClient.name"
                                      required
                                      label="Name"
                                    ></v-text-field>
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
                                      v-model="selectedClient.email"
                                      label="Email"
                                      required
                                    ></v-text-field>
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
                                      v-model="selectedClient.address"
                                      label="Address"
                                      required
                                    ></v-text-field>
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
                                      v-model="selectedClient.created_at"
                                      label="Created"
                                      required
                                    ></v-text-field>
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
                                      required
                                      v-model="productName"
                                      label="Product Name"
                                    ></v-text-field>
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
                                      required
                                      v-model="productPrice"
                                      label="Price"
                                      placeholder="US$  0,00"
                                    ></v-text-field>
                                  </v-col>

                                </v-row>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="12"
                                  >
                                    <v-textarea
                                      required
                                      v-model="description"
                                      name="input-7-1"
                                      label="Description"
                                      outlined
                                    ></v-textarea>
                                  </v-col>

                                  <v-col cols="12"
                                    md="12">

                                  </v-col>


                                </v-row>

                                    <v-btn
                                      @click="sendInvoice(selectedClient)"
                                      :disabled="productName === '' || productPrice === '' || description === '' || buttonDisabled === true" 
                                      rounded
                                      color="primary"
                                      dark
                                    >
                                      Send Invoice
                                    </v-btn>


                              </v-container>
                            </v-form>

                            <v-form v-else v-model="valid">
                              <v-container>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
                                      v-model="name"
                                      required
                                      label="Name"
                                    ></v-text-field>
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
                                      v-model="email"
                                      label="Email"
                                      required
                                    ></v-text-field>
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
                                      v-model="address"
                                      label="Address"
                                      required
                                    ></v-text-field>
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
  
                                      label="Created"
                                      required
                                    ></v-text-field>
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
                                      required
                                      v-model="productName"
                                      label="Product Name"
                                    ></v-text-field>
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
                                      required
                                      v-model="productPrice"
                                      label="Price"
                                      placeholder="US$  0,00"
                                    ></v-text-field>
                                  </v-col>

                                </v-row>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="12"
                                  >
                                    <v-textarea
                                      required
                                      v-model="description"
                                      name="input-7-1"
                                      label="Description"
                                      outlined
                                    ></v-textarea>
                                  </v-col>

                                  <v-col cols="12"
                                    md="12">

                                  </v-col>


                                </v-row>

                                    <v-btn
                                      @click="sendInvoiceFinal()"
                                      :disabled="productName === '' || productPrice === '' || description === '' || buttonDisabled === true" 
                                      rounded
                                      color="primary"
                                      dark
                                    >
                                      Send Invoice
                                    </v-btn>


                              </v-container>
                            </v-form>



                        </div>

                        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                            <button  @click="showSingle =  !showSingle" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                                Cancel
                            </button>
                        </div>

                

                    </div>
                </div>
                </div>
                <!-- close Modal -->
                
      </div>

      <v-dialog
          v-if="dialog"
          v-model="dialog"
          width="800"
        >
          <v-card>
            <v-card-title class="headline grey lighten-2">
              Clients | Users
            </v-card-title>

            <v-card-text>


              <table class="mt-4 min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Name
                    </th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Address
                    </th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Email
                    </th>

                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Odd row -->
                  <tr v-for="client in clients" :key="client.id" class="bg-white">
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {{client.name }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {{ client.address}}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {{ client.email }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      <input
                          type="radio"
                          :value="client"
                          v-model="selectedClient"
                        />
                    </td>
                  </tr>
                  <!-- More items... -->
                </tbody>
              </table>



            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>

              <button @click="saveSubscription(productSelected, selectedClient)" :disabled="selectedClient === ''" v-if="productSelected" type="button" class="disabled:opacity-50 inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Save
              </button>

              <v-btn
                color="primary"
                text
                @click="closeDialog()"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>



    

  </div>
</template>

<script>

export default {

  data() {
    return {

      selectedClient: "",
      clients: "",
      dialog: false,
      valid: false,
      name: "",
      email: "",
      address: "",
      productName: "",
      productPrice: "",
      description: "",
      isOpen: false,
      subName: "Silver Membership",
      subPrice: "100",
      subDescription: "You boil the hell out of it. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
      subPeriod: 'Month',

      plans: '',

      showCreate: true,
      showManage: false,
      showSingle: false,

      buttonDisabled: false,

      productSelected: ''

    };
  },

  created() {
    this.getPlans();
  },

  methods: {
    getPlans() {
      window.axios.get("/api/plans").then(res => {
        this.plans = res.data;
      });
    },

    goHome() {
       this.$router.push({ name: "Home" },);
    },

    goLogin() {
       this.$router.push({ name: "Login" },);

    },

    createSub() {
       window.axios.post("/api/createSubscription",{
          id: this.selectedClient.id,
          name: this.subName,
          price: this.subPrice * 100,
          description: this.subDescription,
          period: this.subPeriod
          
          }).then(() => {
            this.getPlans();
            this.$swal('Success!', 'Subscription successfully created')
            this.showManage = true
            this.showCreate = false
        });
    },

    displayCreate() {
      this.showCreate = true
      this.showManage = false
    },

    displayManage() {
      this.showManage = true
      this.showCreate = false
    },

    displaySingle() {
      this.showSingle = !this.showSingle
    },

    sendInvoiceFinal() {
      
        this.buttonDisabled = true;
        window.axios.post("api/createInvoice",{
          id: 1,
          name: this.name,
          address: this.address,
          description: this.description,
          email: this.email,
          productName: this.productName,
          productPrice: this.productPrice
        }).then(() => {
            this.dialog = false;
            this.showSingle = false
        });

    },


    sendInvoice(selectedClient) {
      this.buttonDisabled = true;
      window.axios.post("api/createInvoice",{
        id: selectedClient.id,
        name: selectedClient.name,
        address: selectedClient.address,
        description: this.description,
        email: selectedClient.email,
        productName: this.productName,
        productPrice: this.productPrice
      }).then(() => {
          this.dialog = false;
          this.clients = ""
          this.showSingle = false
      });
    },

    importContacts(value = null) {
      this.productSelected = value
      window.axios.get("/api/users").then(res => {
          this.clients = res.data;
          this.dialog = true;
        });
    },

    closeDialog() {
      this.dialog = false;
      this.clients = "";
      this.productSelected = ""
      this.selectedClient = ""
    },

    saveSubscription(prod, user) {
        window.axios.post("/api/saveSubscription", {
          prodId: prod.id,
          userId: user.id
        }).then(() => {
            this.$swal('Success!', 'Subscription successfully assigned')
            this.dialog = false;
            this.clients = ""
        });
    }


  }
};
</script>
